import Vue from 'vue'
import Router from 'vue-router'
import toHome from './views/toHome.vue'
Vue.use(Router)

export default new Router({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'toHome',
      component: toHome
    },
    {
      path: '/toHome',
      name: 'toHome',
      component: toHome
    },
    {
      path: '/inquire',
      name: 'inquire',
      component: () =>
        import(/* webpackChunkName: "about" */ './views/inquire.vue')
    },
    {
      path: '/intermediate',
      name: 'intermediate',
      component: () =>
        import(/* webpackChunkName: "about" */ './views/intermediate.vue')
    },
    {
      path: '/toShop',
      name: 'toShop',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ './views/toShop.vue')
    },
    {
      path: '/wxpay',
      name: 'wxpay',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ './views/wxpay.vue')
    },
    {
      path: '/intermediateWx',
      name: 'intermediateWx',
      component: () =>
        import(/* webpackChunkName: "about" */ './views/intermediateWx.vue')
    },
    {
      path: '/serviceInformation',
      name: 'serviceInformation',
      component: () =>
        import(/* webpackChunkName: "about" */ './views/serviceInformation.vue')
    },
  ]
})
